import { render, staticRenderFns } from "./personnelmanage-list.vue?vue&type=template&id=39c6fd9c&scoped=true&"
import script from "./personnelmanage-list.vue?vue&type=script&lang=js&"
export * from "./personnelmanage-list.vue?vue&type=script&lang=js&"
import style0 from "./personnelmanage-list.vue?vue&type=style&index=0&id=39c6fd9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6fd9c",
  null
  
)

export default component.exports